<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Your Subscription">

					<b-alert v-bind:show=this.showSuccess variant="success">Subscription updated successfully.</b-alert>
					<b-alert v-bind:show=this.showAlert variant="danger">Subscription update failed. Please try again.</b-alert>

					<div v-if="(this.currentPlan == 'annual') || (this.currentPlan == 'monthly')">
						You are currently subscribed to our <b>{{this.currentPlan}}</b> plan with <b>{{this.currentQuantity}}</b> users.<br>
						<div v-if="(this.renewPlan == 'annual') || (this.renewPlan == 'monthly')">
							Your subscription will be renewed automatically on <b>{{this.renewDate}}</b>.<br>
							<div v-if="(this.renewPlan != this.currentPlan) && (this.renewQuantity != this.currentQuantity)">Your subscription will be changed to our <b>{{this.renewPlan}}</b> plan with <b>{{this.renewQuantity}}</b> users upon renewal.<br></div>
							<div v-else-if="(this.renewPlan != this.currentPlan)">Your subscription will be changed to our <b>{{this.renewPlan}}</b> plan upon renewal.<br></div>
							<div v-else-if="(this.renewQuantity != this.currentQuantity)">Your subscription will be changed to <b>{{this.renewQuantity}}</b> users upon renewal.<br></div>
							<br>
						</div>
						<div v-else>Your subscription will be cancelled on <b>{{this.renewDate}}</b>.<br><br></div>
					</div>
					<div v-else-if="this.currentPlan == 'trial'">You are currently on <b>FREE trial</b>, ending on <b>{{this.renewDate}}</b>.<br><br></div>
					<div v-else-if="this.currentPlan == 'cancel'">You are currently on our <b>FREE</b> plan.<br><br></div>

					<div v-if="!this.showPage">Loading, please wait...</div>
					<div v-if="this.showPage">
						<br><b-row>
							<b-col md="6">
								<b-form-group
									label="Credit Card:"
									label-for="creditCardInput"
									:label-cols="3"
									:horizontal="true">
									<b-form-input plaintext id="creditCardInput" type="text" v-bind:value="(this.creditCardLast4 == '') ? '' : ('****' + this.creditCardLast4)"></b-form-input>
								</b-form-group>
								<b-form-group
									label="Number of Users:"
									label-for="userInput"
									:label-cols="3"
									:horizontal="true">
									<b-form-input plaintext id="userInput" type="text" v-bind:value="this.renewQuantity"></b-form-input>
								</b-form-group>
								<b-form-group
									label="Select Plan:"
									label-for="planInput"
									:label-cols="3"
									:horizontal="true"
									v-if="this.role == 'administrator'">
									<b-form-select id="planInput"
									:plain="true"
									:options="['annual','monthly']"
									v-model="updatedRenewPlan">
									</b-form-select>
								</b-form-group>
							</b-col>
						</b-row><br>
					</div>
					<b-button-toolbar>
							<form action="user-admin/credit-card" method="POST">
								<div id="stripeCheckoutContainer" ref="stripeCheckoutContainer"></div>
								<!--<img src="img/powered_by_stripe.png" width="60" height="13" alt="Powered By Stripe">-->
								<input type="hidden" name="ccToken" v-bind:value="this.token">
								<input type="hidden" name="ccPlan" v-bind:value="this.updatedRenewPlan">
								<input type="hidden" name="ccQuantity" v-bind:value="this.renewQuantity">
								<!--
								<script
									src="https://checkout.stripe.com/checkout.js" class="stripe-button"
									data-key="pk_test_eoEKFdOekoye24ZmoJdcdwAk"
									data-amount="0"
									data-name="TME Track"
									data-description="Update Credit Card"
									data-image="img/logo-symbol.png"
									data-locale="auto"
									data-zip-code="true"
									data-billing-address="true"
									data-panel-label="Update Credit Card"
									data-email="test@test.com"
									data-label="Update Credit Card"
									data-allow-remember-me="false">
								</script>
								-->
							</form>
							<div>&nbsp;</div>
							<form action="user-admin/subscription" method="POST">
								<button v-if="(this.role == 'administrator') && (this.currentPlan != 'trial') && (this.currentPlan != 'cancel') && (this.currentPlan != '')" class="stripe-button-el"><span style="display: block; min-height: 30px;">{{(this.renewPlan == 'cancel') ? 'Renew' : 'Update Plan'}}</span></button>
								<input type="hidden" name="subToken" v-bind:value="this.token">
								<input type="hidden" name="subPlan" v-bind:value="this.updatedRenewPlan">
								<input type="hidden" name="subQuantity" v-bind:value="this.renewQuantity">
							</form>
					</b-button-toolbar>

					<div v-if="this.showPage"><br><br><small>
						The number of users in your subscription is based on the number of active employees, see Manage->Employees in the left navigation pane<br>
						For subscription pricing please visit <a href="https://earnedvalue.app/#pricing" target="_blank">earnedvalue.app/#pricing</a><br>
						For technical assistance please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a>
					</small><br><br><img src="img/powered_by_stripe.png" alt="Powered By Stripe"></div>

				</b-card>

			</b-col>
		</b-row>
	</div>

</template>



<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import {stripeData} from '@/shared/stripe-settings'
import axios from 'axios'

export default {
	name: 'subscription',

	data: () => {
		return {
			showSuccess: false,
			showAlert: false,
			showPage: false,
			currentCognitoUser: null,
			email: '',
			role: '',
			company: '',
			currentPlan: '',				//annual, monthly, trial, cancel
			currentQuantity: null,
			renewPlan: '',					//annual, monthly, cancel
			renewQuantity: null,
			renewDate: '',
			updatedRenewPlan: 'annual',		//annual, monthly
			creditCardLast4: '',
			token: ''

		}
	},

	mounted() {
		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentCognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}
						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.role = result[i].getValue();
						}


							axios.get('/user-admin/stripe', {params:{token:vueInstance.token}})
                				.then(function (response) {
									vueInstance.email = response.data.email;
									vueInstance.currentPlan = response.data.currentPlan;
									vueInstance.currentQuantity = response.data.currentQuantity;
									vueInstance.renewDate = response.data.renewDate;
									vueInstance.renewPlan = response.data.renewPlan;
									vueInstance.renewQuantity = response.data.renewQuantity;
									vueInstance.creditCardLast4 = response.data.creditCardLast4;

									if (vueInstance.role == 'administrator') {
										var stripeCheckoutText = '';
										if ((vueInstance.currentPlan == 'trial') || (vueInstance.currentPlan == 'cancel'))
											stripeCheckoutText = 'Subscribe';
										else
											stripeCheckoutText = 'Update Credit Card';

										let stripeCheckout = document.createElement('script');
										stripeCheckout.setAttribute('src',"https://checkout.stripe.com/checkout.js");
										stripeCheckout.setAttribute('class',"stripe-button");
										stripeCheckout.setAttribute('data-key',stripeData.publishableKey);
										stripeCheckout.setAttribute('data-amount',"0");
										stripeCheckout.setAttribute('data-name',"Earned Value App");
										stripeCheckout.setAttribute('data-image',"img/logo-symbol.png");
										stripeCheckout.setAttribute('data-locale',"auto");
										stripeCheckout.setAttribute('data-zip-code',"true");
										stripeCheckout.setAttribute('data-billing-address',"true");
										stripeCheckout.setAttribute('data-allow-remember-me',"false");
										stripeCheckout.setAttribute('data-email',vueInstance.email);
										stripeCheckout.setAttribute('data-description',stripeCheckoutText);
										stripeCheckout.setAttribute('data-panel-label',stripeCheckoutText);
										stripeCheckout.setAttribute('data-label',stripeCheckoutText);

										vueInstance.$refs.stripeCheckoutContainer.appendChild(stripeCheckout);
									}

									vueInstance.showPage = true;

								})
								.catch(function (error) {
								});

					});
				}

			});
		}


	}

}
</script>



<style>

</style>
